export const SELECT_SORTING = 'SELECT_SORTING';
